import React from 'react';

import FormikInput from "components/input/new/FormikInput";

function SenderNameField(props) {
    return (
        <FormikInput
            name={'senderName'}
            label={'shippingMethods.form.field.senderName.label'}
            placeholder={'shippingMethods.form.field.senderName.placeholder'}
            required={true}
        />
    );
}

export default SenderNameField;
